import {
  ACCESSTOKEN,
  POOL,
  TOKEN_NOT_AUTHORIZED_ERR_MSG
} from "../AppConstants";
import {v4 as uuidv4} from "uuid";
import store from "../store";
import {
  logoutUserClearLocalStorage,
  setLoggedInUser
} from "../actions";

export async function invokeAuthorization(url, request) {
  return fetch(url, request)
  .then(data => data.json())
  .catch(error => {
    console.log('Authorization caught error:', error);
  });
}

// Verify JWT validity and throw Error if invalid/expired
export const authorizeToken = async () => {
  const token = store.getState()?.userSession?.token;
  if (token) {
    let requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-request-id': uuidv4()
      },
      body: JSON.stringify({
        [ACCESSTOKEN]: token,
        [POOL]: process.env.REACT_APP_SESSION_POOL_NAME
      })
    };

    const authorizeResponse = await invokeAuthorization(
      process.env.REACT_APP_SESSION_AUTHORIZATION_URL, requestOptions);

    if (authorizeResponse?.success) {
      let userSession = {
        'token': token,
        'merchant': authorizeResponse?.merchant,
        'username': store.getState()?.userSession?.username
      };
      store.dispatch(setLoggedInUser(userSession));
    } else {
      logoutUserClearLocalStorage();
      throw TOKEN_NOT_AUTHORIZED_ERR_MSG;
    }
  }
}
